import dayjs from 'dayjs';
import { isDayjs } from 'src/utils/validations';
export const getDurationInHoursAndMinutes = (startTime, endTime = dayjs()) => {
    const start = isDayjs(startTime) ? startTime : dayjs(startTime);
    const end = isDayjs(endTime) ? endTime : dayjs(endTime);
    const dur = dayjs.duration(end.diff(start));
    const isNegative = dur.asMilliseconds() < 0;
    let hours = Math.floor(dur.asHours());
    let mins = Math.floor(dur.asMinutes()) - (hours * 60);
    hours = Math.abs(hours);
    mins = Math.abs(mins);
    return `${isNegative ? '-' : ''}${hours < 10 ? `0${hours}` : hours}:${mins < 10 ? `0${mins}` : mins}`;
};
export const isWeekend = (date) => {
    const d = isDayjs(date) ? date : dayjs(date);
    return d.isoWeekday() > 5;
};
